import styled from "styled-components";

import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../../constants/Styles";
import { MAX_BODY_SIZE } from "../ReviewBoardFlowStyles";

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  font-weight: ${FONT_WEIGHT.weight500};
  width: 100%;
  align-items: center;
  margin-bottom: 1rem;
`;

const HeaderGroup = styled.div<{ largeGap?: boolean }>`
  display: flex;
  gap: ${({ largeGap }) => (largeGap ? "2rem" : "1rem")};
`;

const HeaderText = styled.div`
  font-size: ${FONT_SIZE.size18};
`;

const Sorting = styled.div`
  display: flex;
  align-items: center;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.75rem;

  > img {
    margin-right: 0.5rem;
  }
`;

const TableContainer = styled.div`
  max-width: ${MAX_BODY_SIZE};
  flex: 1;
`;

const EmptyBOM = styled.div`
  text-align: center;
  color: ${COLORS.secondaryLight};
`;

export {
  Header,
  HeaderText,
  Sorting,
  IconContainer,
  HeaderGroup,
  TableContainer,
  EmptyBOM,
};
